export default "__VITE_ASSET__DJdbbQZ___"